import { createFeatureSelector, createSelector } from '@ngrx/store';

import { accountVerificationFeatureKey, State } from './account-verification.reducer';

const getAccountVerificationFeature = createFeatureSelector<State>(accountVerificationFeatureKey);

export const selectAccountVerificationCallState = createSelector(getAccountVerificationFeature, (state) => {
   return state.callState;
});

export const selectAccountVerificationSubmitCallState = createSelector(getAccountVerificationFeature, (state) => {
   return state.submitState;
});

export const selectUserId = createSelector(getAccountVerificationFeature, (state) => {
   return state.accountVerification?.UserId;
});

export const selectCanAccountBeFinalized = createSelector(getAccountVerificationFeature, (state) => {
   return state.canAccountBeFinalized;
});

export const selectAccountVerificationUsername = createSelector(getAccountVerificationFeature, (state) => {
   return state.accountVerification?.Username;
});
